import { TableCell } from '@mui/material'
import EditField from 'components/DocumentDetail/Editor/EditField'
import { Field } from 'components/DocumentDetail/types'

interface Props extends Field {
  defaultValue: any
  onFocus: (name: string) => void
}

function ItemCell({ onFocus, ...field }: Props) {
  const { name } = field
  const isItemName = /itemName$/.test(name) || /itemDate$/.test(name)

  const compProps = {
    ...field.compProps,
    onFocus,
  }
  return (
    <TableCell
      key={name}
      sx={{ p: 1, '&:last-child': { pr: 1 }, minWidth: isItemName ? 240 : 120 }}
    >
      <EditField {...field} compProps={compProps} />
    </TableCell>
  )
}
export default ItemCell
